import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../views/buttons/Button";
import SeoButton from "../../../views/buttons/Button";
import AddSectionButton from "../../../views/buttons/Button";
import img1 from "../../../assests/img/hotel-image.png";
import PageTitleButton from "../../../views/buttons/Button";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { NavigateNextTwoTone } from "@mui/icons-material";
import wbApi from "../../../API/wbApi";
import { useDispatch, useSelector } from "react-redux";
import { eventsPageAction } from "../../../redux/actions/PageAction";
import { RootState } from "../../../redux/store";
import PageEventsSectionCard from "../../../views/datacard/RectangleSectionCard";
import SaveButton from "../../../views/buttons/Button";
import { Draggable } from "react-drag-reorder";
import Wbconfig from "../../../API/Wbconfig.json";
import EventsPageTitleSlider from "./EventsPageTitleSlider";
import SlidingPane from "react-sliding-pane";
import { toast } from "react-toastify";
import EventsSectionSlider from "./EventsSectionSlider";
import EventsSeoSlider from "./EventsSeoSlider";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import { CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import CardWrapper from "../../../views/datacard/CardWrapper";
import {
  CancelConfirmationPrompt,
  ShowConfirmationPrompt,
} from "../../../redux/actions/PromptAction";
import Loader from "../../../views/loader/Loader";

const EventsPage = () => {
  // Data From Redux
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { page_Id } = useSelector((state: RootState) => state.pages);
  const { eventsPageData } = useSelector((state: RootState) => state.pages);

  // States
  const [openTitleSlide, setOpenTitleSlide] = useState<boolean>(false);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openSeoSlide, setOpenSeoSlide] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [allsec, setAllSec] = useState<any[]>([]);
  const [eventsPageSec, setEventsPageSec] = useState<any[]>([]);
  const [updateOrder, setUpdateOrder] = useState<any[]>([]);
  const [eventPageDetails, setEventPageDetails] = useState<any>({});

  // Variables
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { event_page_details } = eventsPageData ?? {};

  useEffect(() => {
    eventsPageDataFetching();
  }, [company_id, template_id]);

  // Fetching About Page Data

  const eventsPageDataFetching = async () => {
    setLoader(true);

    try {
      let eventsPageRes = await wbApi.get(
        `/wb-dashboard/fetch-wb-event-page-details/${company_id}/${template_id}/${page_Id}`
      );
      // console.log("eventsPageData", eventsPageData);
      if (eventsPageRes.data.status === 1) {
        dispatch(eventsPageAction(eventsPageRes?.data));
        setEventPageDetails(eventsPageRes?.data?.event_page_details);
        const eventsPageAllSec = eventsPageRes?.data?.all_sections?.map(
          (item: any) => {
            return { ...item, isChecked: false };
          }
        );
        setAllSec(eventsPageAllSec);
        setEventsPageSec(
          eventsPageRes?.data?.event_page_details?.page_section ?? []
        );
        setLoader(false);
      } else {
        setAllSec([]);
        setEventsPageSec([]);
        setLoader(false);
      }
    } catch {
      // toast.error(CATCH_MESSAGE);
      setLoader(false);
    }
  };

  // Api To ReOrder
  const orderSaveHandler = async () => {
    setSaveLoader(true);
    try {
      let orderReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: eventPageDetails?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateOrder,
          page_type: "Default",
          page_id: page_Id,
        },
        {
          headers: {
            Authorization: "Bearer " + auth_token,
          },
        }
      );
      if (orderReq.data.status === 1) {
        toast.success(orderReq.data.message);
        setDragStatus(false);
        eventsPageDataFetching();
        setSaveLoader(false);
      } else {
        toast.error(orderReq.data.message);
        eventsPageDataFetching();
        setSaveLoader(false);
      }
    } catch (error) {
      toast.error(CATCH_MESSAGE);

      setSaveLoader(false);
    }
  };

  // Ordering Menus
  const positionHandler = (currentPos: any, newPos: any) => {
    const orderSec = [...eventsPageSec];
    const result = orderSec.splice(currentPos, 1);
    const upDateSec = orderSec.splice(newPos, 0, ...result);
    setDragStatus(true);
    setUpdateOrder(orderSec);
    // console.log(orderSec, "orderSec");
  };

  const [dragStatus, setDragStatus] = useState(false);

  // useEffect used to capture the section order if drag action is not triggered.
  useEffect(() => {
    if (!dragStatus) {
      setUpdateOrder(eventsPageSec)
    }
  }, [eventsPageSec, dragStatus])

  // Draggable Handler

  const DraggableRender = useCallback(() => {
    if (eventsPageSec && eventsPageSec.length > 0) {
      return (
        <Draggable onPosChange={positionHandler}>
          {eventsPageSec.map((sec: any, idx: any) => {
            return (
              <>
                <div className="section-card-wrapper" key={sec.id}>
                  <PageEventsSectionCard
                    onDelet={() => {
                      deleteHandler(idx);
                    }}
                    onEdit={() => {
                      navigate(`/section-default/${sec.section_routes}`);
                    }}
                  >
                    {sec.section_names}
                  </PageEventsSectionCard>
                </div>
              </>
            );
          })}
        </Draggable>
      );
    }
    return null;
  }, [eventsPageSec]);

  // Section Delet Handler
  const deleteHandler = (index: any) => {
    dispatch(
      ShowConfirmationPrompt(
        `Are you sure want to delete this ?`,
        "DELETE",
        async () => {
          await deletSecHandler(index);

          dispatch(CancelConfirmationPrompt());
        }
      )
    );
  };
  const deletSecHandler = (index: any) => {
    let eventsPageSections = event_page_details?.page_section;
    eventsPageSections.splice(index, 1);
    deletEventsSecDetails(eventsPageSections);
  };
  // Delet Section Post
  const deletEventsSecDetails = async (updateSec: any) => {
    try {
      let deletEventsSecReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: eventPageDetails?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateSec ?? [],
          page_type: "Default",
          page_id: page_Id ?? "",
        }
      );
      // console.log("deletHomeSecReq", deletAboutSecReq);
      if (deletEventsSecReq.data.status === 1) {
        toast.success(deletEventsSecReq.data.message);
        eventsPageDataFetching();
      } else {
        toast.error(deletEventsSecReq.data.message);
        eventsPageDataFetching();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  return (
    <>
      <div>
        {/* Sub-Header */}
        <div className="wb-subheader">
          {/* BreadCrumbs */}
          <CustomBreadcrumbs
            content={[
              {
                label: "Pages",
                href: "/pages-default",
              },
              {
                label: `Default Pages`,
                href: "/pages-default",
              },
              {
                label: "Events",
              },
            ]}
          />

          <div className="wb-subheader-rightsec">
            <Button
              icon="bi bi-binoculars"
              handleClick={() => {
                setOpenSeoSlide(true);
              }}
            >
              SEO
            </Button>
            <PageTitleButton
              icon="bi bi-info-circle"
              handleClick={() => {
                setOpenTitleSlide(true);
              }}
            >
              Page Title
            </PageTitleButton>
            <Button
              icon="bi bi-arrow-left"
              className="bck-btn"
              handleClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </div>
        </div>
        <div className="wb-divider"></div>
      </div>
      {/* Main Section */}

      {loader ? (
        <div className="middle-loader">
          <Loader />
        </div>
      ) : (
        <>
          <div className=" mt-4 banner-img-wrapper">
            {event_page_details !== null ? (
              event_page_details?.banner ? (
                <img
                  src={`${getImage(event_page_details?.banner)}`}
                  alt={event_page_details?.banner_alt}
                  className="banner-img"
                />
              ) : event_page_details?.video_banner ? (
                <video width="100%" height="300" controls autoPlay>
                  <source
                    src={`${getImage(event_page_details?.video_banner)}`}
                  />
                </video>
              ) : event_page_details?.video_banner_link ? (
                <iframe
                  src={event_page_details?.video_banner_link}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  height="100%"
                  width="100%"
                ></iframe>
              ) : (
                <NoDataComponent message="No Banner Found" />
              )
            ) : (
              <NoDataComponent message="No Data Found" />
            )}

            <div
              className="edit-btn-banner"
              onClick={() => {
                navigate("edit-event-banner");
              }}
            >
              <i className="bi bi-pencil-square"></i>
            </div>
            {/* <div className="banner-titel">
              <div className="b-titel-text">
                {event_page_details?.banner_title ? (
                  <div className="">{event_page_details?.banner_title}</div>
                ) : (
                  <div className="no-banner-titel">
                    TITLE & DESCRIPTION OF THE ABOUT PAGE
                  </div>
                )}
              </div>
            </div> */}
          </div>

          <CardWrapper className="mt-4 about-add-sec-card">
            <Button
              icon="bi bi-plus-lg"
              className="section-btn"
              handleClick={() => {
                setOpen(true);
              }}
            >
              Select Section
            </Button>
          </CardWrapper>

          {/* For Section */}

          <CardWrapper className=" mt-4 mb-4 home-section-save-wrapper">
            {eventsPageSec.length > 0 ? (
              <>
                <DraggableRender />
                <Button
                  className="save-btn"
                  handleClick={() => {
                    orderSaveHandler();
                  }}
                  loader={saveLoader}
                >
                  Save
                </Button>
              </>

            ) : (
              <NoDataComponent message="No Section Found" />
            )}


          </CardWrapper>
        </>
      )}

      {/* For Seo */}

      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openSeoSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenSeoSlide(false)}
      >
        <EventsSeoSlider
          onClose={() => {
            setOpenSeoSlide(false);
          }}
          eventsPageDataFetching={eventsPageDataFetching}
          eventPageDetails={eventPageDetails}
        />
      </SlidingPane>

      {/* For Title */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openTitleSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenTitleSlide(false)}
      >
        <EventsPageTitleSlider
          onClose={() => {
            setOpenTitleSlide(false);
          }}
          eventsPageDataFetching={eventsPageDataFetching}
          eventPageDetails={eventPageDetails}
        />
      </SlidingPane>

      {/* For Section */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={open}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpen(false)}
      >
        <EventsSectionSlider
          onClose={() => {
            setOpen(false);
          }}
          eventsPageDataFetching={eventsPageDataFetching}
          allsec={allsec}
          eventPageDetails={eventPageDetails}
        />
      </SlidingPane>
    </>
  );
};

export default EventsPage;
